var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1127 0C6.30257 0.178667 6.49461 0.355734 6.68286 0.536C6.8565 0.702934 7.02636 0.874134 7.19459 1.03947C7.19459 1.05547 7.19459 1.06453 7.19459 1.0736C7.19459 1.08267 7.19459 1.0928 7.18918 1.0976C5.53226 2.73227 3.87534 4.36587 2.19787 6.01973L7.2 10.952C7.15618 10.9963 7.10101 11.0507 7.04637 11.1061L6.16679 12H6.0586C6.00126 11.9344 5.95041 11.8651 5.88604 11.8043C3.92457 9.86898 1.96255 7.93422 0 6C1.96183 4.06542 3.92385 2.13067 5.88604 0.195733C5.94771 0.134933 6.00126 0.0656 6.0586 0L6.1127 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.41f5b0bfcca0f81f3fff92673fc2e0e1.svg";
export { ForwardRef as ReactComponent };